/// ////////////////////////////////////////////////////////////
/// ////////////////////////////////////////////////////////////
/// ////////////////////// Russian /////////////////////////////
/// ////////////////////////////////////////////////////////////
/// ////////////////////////////////////////////////////////////
import { DASH_LINKS } from "../../../const/AppCardLinks";
/* eslint-disable */
// eslint-disable-next-line import/prefer-default-export
export const data = {
    /// ////////////////////////////////////////////////////////////
    /// /////////////// Interrupt //////////////////////////////////
    /// ////////////////////////////////////////////////////////////
    Interrupt_header: <b>Процесс входа в родительский портал EngagED (Внутренний/Внешний)</b>,
    Interrupt_p1: (
        <>
            Чтобы войти в родительский портал EngagED, вы объедините ваше{" "}
            <b>имя пользователя в родительском портале Infinite Campus</b> (внешний родитель: имя пользователя,
            созданное вами при настройке аккаунта) <u>и</u> <b>@p.dcsdk12.org</b>. Например: если ваше имя пользователя
            в Infinite Campus - <b>jsmith</b>, вы введете <b>jsmith@p.dcsdk12.org</b> в качестве вашего адреса
            электронной почты на следующем экране входа. Ваш <b>пароль</b> тот же, который вы используете для доступа к
            Infinite Campus (внешний родитель: пароль, созданный вами при настройке аккаунта).
        </>
    ),
    Interrupt_p2: (
        <>
            <b>Если вы забыли свои учетные данные для входа в DCSD</b>:<br />
            Используйте эти ссылки, чтобы{" "}
            <a
                href="https://iaas5idm.fischeridentity.com/identity/self-service/dcs/forgotuserid.jsf"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                восстановить свое имя пользователя
            </a>{" "}
            и/или{" "}
            <a
                href="https://iaas5idm.fischeridentity.com/identity/self-service/dcs/kiosk.jsf"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                сбросить свой пароль
            </a>
            .
        </>
    ),
    Interrupt_p3: (
        <>
            <b>Если вы выполнили вышеуказанные шаги и продолжаете испытывать трудности, пожалуйста, свяжитесь с нами</b>
            :<br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Техническая поддержка для родителей - английский
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LFLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Техническая поддержка для родителей - испанский
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LRLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Техническая поддержка для родителей - китайский
            </a>
            <br />
            Центр технической поддержки по номеру <b>303.387.0001</b>
        </>
    ),
    Interrupt_note:
        "ПРИМЕЧАНИЕ: Сотрудники округа, которые в настоящее время являются родителями, должны следовать приведенным выше инструкциям, используя окно браузера в режиме инкогнито или приватный режим и/или другой браузер.",
    Interrupt_submit: "Перейти к входу",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "Добро пожаловать,",
    Main_Nav_HelpfulLinks: "Полезные ссылки",
    Main_Nav_LogOut: "Выйти",
    Main_Nav_HelpfulLinks_LI_s1: "Связаться с медсестрой моего(-их) ученика(-ов)",
    Main_Nav_HelpfulLinks_LI_s2: "Академические календари",
    Main_Nav_HelpfulLinks_LI_s3: "Ресурсы для родителей",
    Main_Nav_HelpfulLinks_LI_s4: "Маршруты автобусов",
    Main_Nav_HelpfulLinks_LI_s5: "Онлайн-платежи",
    Main_Nav_HelpfulLinks_LI_s6: "Меню обедов",
    Main_Nav_Exit: "ВЫХОД",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Global //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Global_Add: "Добавить",
    Global_Add_New_Student: "Добавить нового студента",
    Global_BackToDashboard: "Вернуться к панели управления",
    Global_Close: "Закрыть",
    Global_Completed: "Завершено",
    Global_InProgress: "В процессе",
    Global_GoTo: "Перейти к",
    Global_MoreInfo: "Подробнее",
    Global_No_Student_1: "Добро пожаловать на родительский портал EngagED",
    Global_No_Student_2: "К сожалению, нам не удалось найти студентов, связанных с вашей учетной записью.",
    Global_No_Student_External: (
        <>
            Если вы подаете заявление на открытую запись, нажмите кнопку &ldquo;<strong>Добавить нового студента</strong>&rdquo;,
            чтобы добавить своего ученика. Если вы подаете заявление на нескольких учащихся, вы будете добавлять каждого
            учащегося по отдельности.
        </>
    ),
    Global_No_Student_Guardian: (
        <>
            Если вы не видите своих учащихся, а они в настоящее время зачислены в школу DCSD, обратитесь в Центр
            поддержки IT по телефону <strong>303-387-0001</strong>. Пожалуйста, используйте кнопку &ldquo;
            <strong>Добавить нового студента</strong>&rdquo;, чтобы добавить учащегося, только если он в настоящее время не
            зачислен в школу DCSD, и вы подаете заявление на открытую запись.
        </>
    ),
    Global_NotStarted: "Не начато",
    Global_Open: "Открыто",
    Global_OpenFrom: "Открыто с ", // [DATE] - [DATE]
    Global_Status: "Статус",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "Панель опекуна DCSD",
    Breadcrumb_EPR: "Опекун DCSD",
    Breadcrumb_Translations: "Переводы экспериментальные",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// EPR /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    EPR_Failure1: "К сожалению, нам не удалось получить EPR PDF для студента за",
    EPR_Failure2: "При обращении в округ за поддержкой, пожалуйста, предоставьте следующую информацию:",
    EPR_NoData: "Для студента не найдено исторических EPR.",
    EPR_Success: "PDF-файл EPR успешно получен для студента.",
    EPR_Title: "Архивированные ресурсы EPR",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// No Apps /////////////////////////////
    /// /////////////////////////////////////////////////////////
    NoApp_Body1: "Все окна подачи заявлений в настоящее время закрыты.",
    NoApp_Body2: "Если вы считаете, что это ошибка, обратитесь за поддержкой в округ.",
    NoApp_Closed: "Закрыто",
    NoApp_Header: "Нет доступных заявлений",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Welcome Page ////////////////////////////
    /// /////////////////////////////////////////////////////////
    Welcome_Header: "Добро пожаловать в панель опекуна DCSD",
    Welcome_Tagline: "Сотрудничество с родителями для выбора наилучшей учебной среды для каждого ученика.",
    Welcome_p1: (
        <p>
            Мы помогаем семьям найти наилучший образовательный вариант для их детей.{" "}
            <a
                href="https://www.dcsdk12.org/schools-academics/schools/school-locator-map"
                rel="noreferrer"
                target="_blank"
            >
                Узнать больше
            </a>
        </p>
    ),
    Welcome_p2: (
        <p>
            Семьи, желающие зачислить своего ребенка в школу, отличную от школы по месту жительства, должны использовать
            этот инструмент для подачи заявки на открытую запись (Open Enrollment) в один из двух периодов открытой
            записи, ежегодно предлагаемых DCSD.{" "}
            <span className="highlight">
                Вам не нужно использовать этот инструмент открытой записи, чтобы остаться в школе{" "}
                <b>текущего зачисления</b>.
            </span>
        </p>
    ),
    Welcome_h5_1: (
        <h5>
            <a
                href="https://docs.google.com/document/d/1sr3ARzZGUmmJdNSjlWnLM0QWj8ipKHJb3RkwLr72_P0/edit"
                rel="noreferrer"
                target="_blank"
            >
                Нажмите здесь
            </a>{" "}
            для получения пошаговых инструкций по использованию инструмента.
        </h5>
    ),
    Welcome_ImportantDates: "Важные даты/время",
    Welcome_FirstWindow: "Первый период",
    Welcome_SecondWindow: "Второй период",
    Welcome_ul_li1a:
        "Первый раунд открытой записи НЕ является принципом «первым пришел — первым обслужен»; у вас есть время до ", // [DATE]
    Welcome_ul_li1b: " для завершения этого процесса.",
    Welcome_ul_li2a: "Для первого раунда вы можете изменять свой выбор в заявке на открытую запись в любое время до ", // [DATE]
    Welcome_ul_li3: "Школы будут делать предложения семьям в зависимости от наличия мест.",
    Welcome_ul_li4a: "Предложения будут видны вам только после ", // [DATE]
    Welcome_ul_li4b: (
        <>
            Вы можете снова войти в{" "}
            <a href={DASH_LINKS.guardian}>
                Родительский портал EngagED
            </a>{" "}
            начиная с
        </>
    ), // [DATE]
    Welcome_ul_li4c: " , чтобы проверить любые полученные вами предложения.",
    Welcome_ul_li5a: "У вас есть время до ", // [DATE]
    Welcome_ul_li5b: (
        <>
            , чтобы принять предложение об открытой записи от школы через{" "}
            <a href={DASH_LINKS.guardian}>
                Родительский портал EngagED.
            </a>
        </>
    ),
    Welcome_ul_li6a:
        "Если ваша заявка на открытую запись не будет принята ни одной школой, или вы не вошли в систему и не приняли свое предложение, вы будете автоматически помещены в список ожидания второго раунда открытой записи, который действует с ", // [DATE RANGE]
    Welcome_NotAvailable: "Процесс открытой записи на текущий учебный год пока недоступен.",
    Welcome_PreschoolInfo: "Информация о детском саде/дошкольном учреждении",
    Welcome_Note: "ПРИМЕЧАНИЕ",
    Welcome_NoSupport: "Это приложение не поддерживает подачу заявок в дошкольные учреждения DCSD.",
    Welcome_PreschoolsLink: (
        <>
            Для дошкольных учреждений DCSD{" "}
            <a href="https://www.dcsdk12.org/schools-academics/schools/preschool" rel="noreferrer" target="_blank">
                <b>нажмите на эту ссылку</b>.
            </a>
        </>
    ),
    Welcome_PreschoolEnrollment: (
        <>
            Родители, желающие зачислить своих трех- и четырехлетних детей в дошкольные учреждения округа, не проходят
            процедуру открытой записи. Регистрация в дошкольные учреждения будет проходить в начале января. Перейдите по
            этой{" "}
            <a href="https://www.dcsdk12.org/schools-academics/schools/kindergarten" rel="noreferrer" target="_blank">
                <b>ссылке</b>{" "}
            </a>
            для получения дополнительной информации.
        </>
    ),
    Welcome_CharterSchoolInfo: "Информация о чартерных школах (Charter School)",
    Welcome_CharterSchoolInclude: (
        <>
            <h5>Следующие чартерные школы будут использовать этот инструмент в этом году:</h5>
            <a
                href="https://www.dcsdk12.org/schools_academics/schools/charter_schools"
                rel="noreferrer"
                target="_blank"
            >
                <u>
                    Пожалуйста, свяжитесь напрямую со всеми другими чартерными школами, чтобы узнать больше о вариантах
                    зачисления в чартерные школы.
                </u>
            </a>
            <ul className="charter-school-li">
                <li>
                    <i>Aspen View Academy</i>
                </li>
                <li>
                    <i>Ben Franklin Academy</i>
                </li>
                <li>
                    <i>Challenge to Excellence</i>
                </li>
                <li>
                    <i>DCS Montessori Charter</i>
                </li>
                <li>
                    <i>Leman Academy of Excellence</i>
                </li>
                <li>
                    <i>Parker Performing Arts School</i>
                </li>
                <li>
                    <i>SkyView Academy</i>
                </li>
                <li>
                    <i>STEM Academy</i>
                </li>
                <li>
                    <i>World Compass Academy</i>
                </li>
            </ul>
        </>
    ),
    Welcome_TransportationInfo: "Информация о транспорте",
    Welcome_TransportationBody:
        "Транспортировка для учащихся-резидентов, получивших разрешение посещать школу или программу за пределами их района проживания, обеспечивается их родителем/опекуном.",
    Welcome_GeneralInfo: "Общая информация",
    Welcome_GeneralInfo_ul2_li1:
        "Вы можете запросить отправку электронного письма с подтверждением после подачи вашей заявки.",
    Welcome_GeneralInfo_ul2_li2:
        "Вы можете выбрать получение информации о вашем выборе по электронной почте после завершения открытой записи.",
    Welcome_GeneralInfo_ul2_li3:
        "Второй раунд открытой записи осуществляется по принципу «первым пришел — первым обслужен». Учащиеся, подающие заявку на открытую запись только во втором раунде, помещаются в список ожидания после тех, кто уже находится в списке ожидания с первого раунда.",
    Welcome_GeneralInfo_ul2_li4: (
        <>
            Если вы зачислены по открытой записи в школу по месту жительства или посещаете чартерную школу, но хотели бы
            вернуться в школу по месту жительства, связанную с вашим адресом, на следующий учебный год, вы должны подать{" "}
            <a
                href="https://www.dcsdk12.org/about/departments/choice-programming/forms"
                rel="noreferrer"
                target="_blank"
            >
                заявление о намерении вернуться
            </a>{" "}
            <b>до</b>
        </>
    ), // [DATE],
    Welcome_GeneralInfo_li5: (
        <>
            Если вы переезжаете в пределах округа, но хотели бы остаться в своей текущей школе, вы можете сделать это,
            подав заявление о{" "}
            <a
                href="https://www.dcsdk12.org/about/departments/choice-programming/forms"
                rel="noreferrer"
                target="_blank"
            >
                намерении остаться
            </a>{" "}
            в любое время.
        </>
    ),

    /// /////////////////////////////////////////////////////////
    /// /////////////// Marquee /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Marquee_Grade: "Класс",
    Marquee_School: "Школа",
    Marquee_Address: "Адрес",
    Marquee_NewStudent: "Новый ученик",
    Marquee_NotAvailable: "Недоступно",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Open Enrollment App /////////////////////
    /// /////////////////////////////////////////////////////////
    OEApp_Header: "Открытая запись (Open Enrollment)",
    OEApp_Btn1: "Начать открытую запись",
    OEApp_Btn2: "Управление выбором школ",
    OEApp_Btn3: "Просмотр информации об ученике",
    OEApp_Btn4: "Редактировать информацию об ученике",
    OEApp_Btn5: "Выберите варианты школ",
    OEApp_Btn6: "Открытая регистрация",
    OEApp_Schools: "Сделанные выборы школ",
    OEApp_School: "Сделанный выбор школы",
    OEApp_NoSchools: "Выбор школы не сделан",
    OEApp_1School: "1 выбор школы сделан",
    OEApp_MoreSchools: "выборов школы сделано",
    OEApp_Body:
        "Процесс подачи заявок для родителей на рассмотрение зачисления их ученика(ов) в школы по месту жительства и чартерные школы DCSD.",
    OEApp_Round1: "Раунд 1",
    OEApp_Round2: "Раунд 2",
    OEApp_RoundClosed: "Раунд 1 закрыт. Пожалуйста, вернитесь для Раунда 2, начиная с ", // [DATE]
    OEApp_SchoolChoices: "Выбор школ",
    OEApp_RequestStatus: "Статус заявки",
    OEApp_LanguageChoice: "Выбор языка",
    OEApp_KinderChoice: "Выбор детского сада",
    OEApp_LanguageOffer: "Предложение по языку",
    OEApp_KinderOffer: "Предложение по детскому саду",
    OEApp_FullDay: "Полный день",
    OEApp_HalfDayPM: "Пол дня (после обеда)",
    OEApp_HalfDayAM: "Пол дня (до обеда)",
    OEApp_Spanish: "Испанский",
    OEApp_Mandarin: "Мандаринский",
    OEApp_French: "Французский",
    OEApp_NewStudent: "Новый ученик",
    OEApp_ACCEPT_OFFER: "Предложение принято",
    OEApp_CANCELLED_REQUEST: "Заявка отменена",
    OEApp_CHANGED_ENROLLMENT: "Отчислен",
    OEApp_CHOICE_CREATED: "Выбор школы создан",
    OEApp_CHOICE_INCOMPLETE: "Выбор не завершен",
    OEApp_DENY_OFFER: "Предложение отклонено",
    OEApp_DENY_REQUEST: "Заявка отклонена",
    OEApp_ENROLLED: "Зачислен",
    OEApp_INVALID: "Недействительно",
    OEApp_MAKE_OFFER: "Предложение сделано",
    OEApp_MAKE_OFFER_PENDING: "Ожидание предложения",
    OEApp_NO_RESPONSE: "Нет ответа",
    OEApp_WAIT_LIST: "В списке ожидания",
    OEApp_REQUEST: "Заявка подана",
    OEApp_UNENROLLED: "Отчислен",
    OEApp_UNAVAILABLE: "Недоступно",
    /// /////////////////////////////////////////////////////////
    /// ///////////// Express Check-In App //////////////////////
    /// /////////////////////////////////////////////////////////
    ECApp_Header: "Экспресс-регистрация (Express Check-In)",
    ECApp_Btn1: "Экспресс-регистрация",
    ECApp_Body:
        "Ежегодный процесс регистрации учащихся для родителей для обновления и/или проверки текущей информации об адресе домохозяйства, согласии на использование медиафайлов, контактах для экстренной связи, состоянии здоровья и многом другом.",
    /// ////////////////////////////////////////////////////////
    /// ///////// Elementary Progress Report App ///////////////
    /// ////////////////////////////////////////////////////////
    EPRApp_Body: "Скоро. Просмотр отчета об успеваемости вашего ученика начальной школы.",
    EPRApp_Header: "Отчет об успеваемости в начальной школе",
    EPRApp_Btn1: "Отчет об успеваемости начальной школы",
    EPRApp_Btn2: "Просмотр архивированных EPR",
    EPRApp_Semester: "Семестр",
    EPRApp_1stSemester: "Первый семестр",
    EPRApp_2ndSemester: "Второй семестр",
    /// ////////////////////////////////////////////////////////
    /// /////////// Assessment Excusals App ////////////////////
    /// ////////////////////////////////////////////////////////
    AEApp_Body: "Управление запросами на отказ от оценок.",
    AEApp_Header: "Освобождения от оценок",
    AEApp_Excusal: "Освобождение",
    AEApp_Excusals: "Освобождения",
    AEApp_NoExcusals: "Нет освобождений",
    AEApp_MoreExcusals: "освобождений",
    AEApp_Btn1: "Освобождение от оценки",
    /// ////////////////////////////////////////////////////////
    /// /////////////// Transportation App /////////////////////
    /// ////////////////////////////////////////////////////////
    BusApp_Body1:
        "Подать заявку на проездной на автобус и/или выбрать варианты ежегодной/ежеквартальной оплаты проезда на автобусе.",
    BusApp_Body2: "Подать заявление на получение проездного билета",
    BusApp_Header: "Транспорт",
    BusApp_Btn1: "Транспорт",
    BusApp_BusPass: "Проездной на автобус выдан",
    BusApp_NoBusPass: "Проездной на автобус не выдан",
    BusApp_NotRiding: "Не пользуется автобусом",
    BusApp_NotRidingReason1: "Вы указали, что ", // [NAME]
    BusApp_NotRidingReason2: " не будет пользоваться автобусом в этом году.",
    BusApp_NotRidingReason3: "Вы указали, что ученик не будет ездить на автобусе в этом году",
    BusApp_Processing: "Обработка проездного на автобус",
    BusApp_AnnualOffer: "Предложение годового проездного до ", // [DATE]
    BusApp_Quarterly: "Вы выбрали ежеквартальную оплату. Вы можете выбрать годовую оплату до ", // [DATE]
    BusApp_BusPassIssued: (
        <>
            Ваш проездной на автобус выдан. Теперь вы можете пользоваться автобусом.
            <br />
            Если карта повреждена или утеряна, можно запросить замену проездного через{" "}
            <a
                className="anchor"
                href="https://www.k12insight.com/Lets-Talk/DialogueCustom.aspx?k=WK3Z6DLT@DG2T5DLT"
                rel="noreferrer"
                target="_blank"
            >
                Let&apos;s Talk
            </a>
            .
        </>
    ),
    BusApp_BusPassProcessing: "Ваша заявка на проездной на автобус все еще обрабатывается.",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Loading Messages ////////////////////////
    /// /////////////////////////////////////////////////////////
    Loading_1: "Загрузка открытой записи",
    Loading_2: "Загрузка экспресс-регистрации",
    Loading_3: "Загрузка отчета об успеваемости",
    Loading_4: "Загрузка освобождений от оценок",
    Loading_5: "Загрузка транспорта",
    Loading_6: "Загрузка опроса",
    Loading_7: "Загрузка широковещательного сообщения"
};
/* eslint-enable */
